<template>
  <div class="mx-6 my-6 relative">
    <div class="sm:flex sm:items-center">
      <div class="flex-auto flex items-center space-x-5">
        <div class="flex-shrink-0">
          <div class="relative bg-orange-600/70 rounded-xl p-1">
            <mdicon name="forum-outline" size="62" class="text-orange-100" aria-hidden="true"></mdicon>
          </div>
        </div>
        <div class="">
          <h1 class="text-2xl font-bold text-gray-900">Chat Bots</h1>
          <p class="text-sm font-medium text-gray-500">Manage Chat Bots in your account</p>
        </div>
      </div>

      <div class="flex items-center mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <!--<button
          v-if="showDelete"
          type="button"
          class="mr-2 flex items-center gap-x-1 rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          @click="onDeleteUsers"
        >
          <mdicon name="minus-circle-outline" class="h-6 w-6" aria-hidden="true"></mdicon>
          Delete
        </button>-->
      </div>
    </div>

    <div class="mt-4">
      <ManageProviderEmails :integrations-allowed="['freshchat']" type="chat" />
    </div>
  </div>
</template>

<script setup>
  import { useSettingsStore } from '@/store/SettingsStore';
  import ManageProviderEmails from '@/components/Settings/ManageProviderEmails.vue';
  import { ref, computed } from 'vue';

  const settingsStore = useSettingsStore();
</script>
